import React from "react"
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { updateTestimonial, updateStatusTestimonial, APIpath } from '../actions'
import { getTestimonial, getRedirect } from '../reducers'
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    CircularProgress,
    useColorModeValue,
    Textarea,
    Image
} from '@chakra-ui/react'
import { Formik } from 'formik'
import { FormValidator } from '../utils/validationForms'
import Layout from '../layout'
import InputFile from "../components/InputFile"
import placeholder from '../multimedia/placeholder.jpg'

const replaceImage = (error) => {
    error.target.src = placeholder;
}

class TestimonialEdit extends React.Component {

    getColor = () => useColorModeValue('white', 'gray.800')

    render() {

        const { updateTestimonial, updateStatusTestimonial, testimonial, redirect } = this.props

        return (
            <Layout>
                {redirect && <Redirect to="/testimonial" />}
                <Box w={'full'} bg={this.getColor} rounded={'md'} m={3} p={6} >
                    <Formik
                        initialValues={{
                            titulo: testimonial.cTitulo,
                            descripcion: testimonial.cDescripcion,
                            image: null
                        }}
                        validate={values => FormValidator([
                            { field: 'titulo', value: values.titulo, rules: ['required'] },
                            { field: 'descripcion', value: values.descripcion, rules: ['required'] },
                            { field: 'image', value: values.image, rules: ['required'] },
                        ])}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            setSubmitting(true)
                            const formData = new FormData()
                            for (let value in values) {
                                formData.append(value, values[value])
                            }
                            formData.append('id', testimonial.id)
                            Promise.resolve(updateTestimonial(formData, testimonial.id))
                                .then(() => {
                                    setSubmitting(false)
                                    resetForm()
                                })
                        }}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>

                                <FormControl isInvalid={errors.titulo && touched.titulo}>
                                    <FormLabel>Titulo</FormLabel>
                                    <Input name="titulo" onChange={handleChange} onBlur={handleBlur} value={values.titulo} />
                                    <FormErrorMessage>{errors.titulo}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.image && touched.image}>
                                    <FormLabel>Imagen actual</FormLabel>
                                    <Image src={`${APIpath}/testimonial/image/${testimonial.id}`} alt={"preview"} h={"200px"} w={"auto"} m={"auto"} onError={replaceImage} />

                                    <InputFile name={"image"} label={"Imágen"} setFieldValue={setFieldValue} value={values.image} />
                                    <FormErrorMessage>{errors.image}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.descripcion && touched.descripcion}>
                                    <FormLabel>Descripción</FormLabel>
                                    <Textarea size="lg" name={"descripcion"} onChange={handleChange} onBlur={handleBlur} value={values.descripcion} />
                                    <FormErrorMessage>{errors.descripcion}</FormErrorMessage>
                                </FormControl>

                                <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                    {isSubmitting ? <CircularProgress /> : 'Actualizar'}
                                </Button>
                            </form>
                        )}
                    </Formik>
                    <Button onClick={() => {
                        updateStatusTestimonial(testimonial.id)
                    }} colorScheme="easycar2" type="submit" mt={4} > {testimonial.active ? "Ocultar" : "Activar"} </Button>
                </Box>
            </Layout>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    testimonial: getTestimonial(state, ownProps.match.params.id),
    redirect: getRedirect(state)
})

const mapDispatchToProps = { updateTestimonial, updateStatusTestimonial }

export default connect(mapStateToProps, mapDispatchToProps)(TestimonialEdit)
